import React from 'react';
import { Option } from 'react-dropdown';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
	DefaultFeedCurve,
	ESFReader,
	IMoveMatingToMatingSetting,
	MoveMatingToMatingSetting,
	MoveToLocationTypes,
	WorkListType,
} from 'shared/api/api';
import { ExceptionMessage } from 'shared/helpers/exception-message';
import { generateFeedCurveOptions } from 'shared/helpers/feed-curve-helper';
import { deepCopy } from 'shared/helpers/general-helpers';
import { ESFReaderOptions } from 'shared/helpers/work-list-helpers/esf-list-helpers/generel-esf-list-helper';
import {
	GetMoveMatingToMatingOption,
	ResetDataOnMoveListSetups,
} from 'shared/helpers/work-list-helpers/move-to-helpers/moving-lists-helper';
import { SaveWorkListSetting } from 'shared/state/ducks/work-list-settings/operations';
import { localized } from 'shared/state/i18n/i18n';
import { WebAppState } from 'web/state/store.web';
import { ViewWeb } from 'web/view/components/utils/web-view';
import { TextWeb } from 'web/web-helpers/styled-text-components';
import { showAlert } from '../../skiold-alert/skiold-alert';
import { SkioldButton } from '../../skiold-components/skiold-button/skiold-button';
import { SkioldCheckbox } from '../../skiold-components/skiold-checkbox/skiold-checkbox';
import { SkioldFormDropdown } from '../../skiold-components/skiold-dropdown/skiold-form-dropdown';
import { SkioldFormsWrapper } from '../../skiold-components/skiold-forms-wrapper/skiold-forms-wrapper';
import { FormRow } from '../../skiold-components/skiold-forms-wrapper/skiold-forms-wrapper-types';
import { SkioldFormIntegerInput } from '../../skiold-components/skiold-integer-input/skiold-form-integer-input';
import '../list-setup.scss';
import { getAvailablityRow, getSkioldInputRow } from '../work-list-helper';
import './move-to-pregnant-setup.scss';

interface PropsFromParent {
	workListType: WorkListType;
}

const mapStateToProps = (state: WebAppState) => {
	return {
		workListSettings: state.workListSettings.entities,
		siteId: state.profile.active!.siteId,
		// feedCurves: state.site.site.feedCurves,
		feedCurvesOptions: generateFeedCurveOptions(state.esfStatus.availableCurves),
	};
};

const mapDispatchToProps = (dispatch: Dispatch, props: {}) => ({
	saveWorkListSetting: (moveMatingToMatingSetup: IMoveMatingToMatingSetting) =>
		SaveWorkListSetting(moveMatingToMatingSetup)(dispatch),
});

export interface MoveMatingToMatingSetupState {
	moveMatingToMatingSetup: IMoveMatingToMatingSetting;
	selectedOption: Option;
	selectedReaderOption: Option;
	options: Option[];
	// selectedFeedCurve: Option;
	// feedCurves: Option[];
}

type MoveMatingToMatingSetupProps = ReturnType<typeof mapStateToProps> &
	ReturnType<typeof mapDispatchToProps> &
	PropsFromParent;
class MoveMatingToMatingSetup extends React.PureComponent<MoveMatingToMatingSetupProps, MoveMatingToMatingSetupState> {
	constructor(props: MoveMatingToMatingSetupProps) {
		super(props);
		this.state = {
			moveMatingToMatingSetup: this.getWorkListSetting(props.workListType),
			options: GetMoveMatingToMatingOption(),
			selectedOption: { label: '', value: '' },
			selectedReaderOption: { label: ' ', value: ' ' },
		};
	}

	public componentDidMount() {
		let initSetting = {};
		if (this.state.moveMatingToMatingSetup.selectedType !== undefined) {
			initSetting['selectedOption'] = {
				label: localized(this.state.moveMatingToMatingSetup.selectedType),
				value: this.state.moveMatingToMatingSetup.selectedType,
			};
		}

		this.setState(initSetting);
	}

	public toggleShowOnWeb = () => {
		this.setState(prevState => ({
			moveMatingToMatingSetup: {
				...prevState.moveMatingToMatingSetup,
				showOnWeb: !this.state.moveMatingToMatingSetup.showOnWeb,
			},
		}));
	};

	public toggleShowOnApp = () => {
		this.setState(prevState => ({
			moveMatingToMatingSetup: {
				...prevState.moveMatingToMatingSetup,
				showOnApp: !this.state.moveMatingToMatingSetup.showOnApp,
			},
		}));
	};

	public moveMatingToMatingSetupChanged(setup: IMoveMatingToMatingSetting) {
		this.setState({
			moveMatingToMatingSetup: setup,
		});
	}

	public render() {
		return (
			<ViewWeb className="move-to-pregnant-setup">
				<ViewWeb className="view-container">
					<TextWeb className="setup-header">{localized('Setup')}</TextWeb>
					<SkioldFormsWrapper formRows={this.getFormRows()} containerClassName="wrapper-container" />
					{this.renderButtons()}
				</ViewWeb>
			</ViewWeb>
		);
	}

	private save() {
		if (!this.validate(this.state.moveMatingToMatingSetup)) {
			return;
		}

		let moveMatingToMatingSetup = deepCopy(this.state.moveMatingToMatingSetup);
		moveMatingToMatingSetup.selectedType = this.state.selectedOption.value as MoveToLocationTypes;
		ResetDataOnMoveListSetups(moveMatingToMatingSetup);
		moveMatingToMatingSetup.siteId = this.props.siteId;
		this.setState({ moveMatingToMatingSetup });
		this.props.saveWorkListSetting(moveMatingToMatingSetup);
	}

	private validate(listSetting: IMoveMatingToMatingSetting) {
		if (!listSetting.selectedType) {
			showAlert(localized(ExceptionMessage.VALIDATION_ERROR_CHOOSE_ANIMAL_NOT_SET));
			return false;
		}
		if (listSetting.selectedType === MoveToLocationTypes.MatingBatch) {
			if (!listSetting.batchCycleDays) {
				showAlert(localized(ExceptionMessage.VALIDATION_ERROR_CYCLEDAYS_NOT_SET));
				return false;
			}
		}

		return true;
	}

	private getFormRows() {
		let formRows = new Array<FormRow>();
		formRows.push(this.getBuildingHeader());
		formRows.push(
			getSkioldInputRow(
				setup => this.moveMatingToMatingSetupChanged(setup),
				this.state.moveMatingToMatingSetup,
				'name',
				localized('name'),
			),
		);
		formRows.push(this.getAnimalToListRow());
		if (this.state.selectedOption.value === MoveToLocationTypes.MatingBatch) {
			formRows.push({
				name: localized('pregnantDays'),
				component: (
					<SkioldFormIntegerInput
						onChangeNumber={newNumber =>
							this.valueInMoveMatingToMatingSetupChanged(newNumber, 'batchCycleDays')
						}
						text={this.state.moveMatingToMatingSetup.batchCycleDays}
					/>
				),
			});
		}

		formRows.push(this.getNegativeCycleDaysRow());
		formRows.push(
			getAvailablityRow(
				this.toggleShowOnWeb,
				this.toggleShowOnApp,
				this.state.moveMatingToMatingSetup.showOnWeb!,
				this.state.moveMatingToMatingSetup.showOnApp!,
			),
		);

		return formRows;
	}

	private valueInMoveMatingToMatingSetupChanged(value: any, key: keyof IMoveMatingToMatingSetting) {
		this.setState(prevState => ({
			moveMatingToMatingSetup: {
				...prevState.moveMatingToMatingSetup,
				[key]: value,
			},
		}));
	}

	private getBuildingHeader(): FormRow {
		return {
			header: localized(this.props.workListType),
		};
	}

	private getAnimalToListRow(): FormRow {
		return {
			name: localized('chooseAnimalToList'),
			component: (
				<SkioldFormDropdown
					items={this.state.options}
					selectedValue={this.state.selectedOption}
					onValueChanged={this.animalToListChanged}
				/>
			),
		};
	}

	private animalToListChanged = (option: Option) => {
		this.setState(prevState => ({
			moveMatingToMatingSetup: {
				...prevState.moveMatingToMatingSetup,
				selectedType: option.value as MoveToLocationTypes,
			},
			selectedOption: option,
		}));
	};

	private getReaderRow(): FormRow {
		return {
			name: localized('chooseReader'),
			component: (
				<SkioldFormDropdown
					items={ESFReaderOptions}
					selectedValue={this.state.selectedReaderOption}
					onValueChanged={this.onReaderChanged}
				/>
			),
		};
	}

	private onReaderChanged = (option: Option) => {
		this.setState(prevState => ({
			moveMatingToMatingSetup: {
				...prevState.moveMatingToMatingSetup,
				reader: option.value !== ' ' ? (option.value as ESFReader) : undefined,
			},
			selectedReaderOption: option,
		}));
	};

	private getNegativeCycleDaysRow(): FormRow {
		return {
			name: localized('cycleDaysShownNegative'),
			component: (
				<ViewWeb className="two-checkbox-container">
					<SkioldCheckbox
						onClick={this.SetNegativeCycleDaysToTrue}
						isChecked={this.state.moveMatingToMatingSetup.negativeCycleDays}
					/>
					<TextWeb>{localized('True')}</TextWeb>
					<SkioldCheckbox
						onClick={this.SetNegativeCycleDaysToFalse}
						isChecked={!this.state.moveMatingToMatingSetup.negativeCycleDays}
					/>
					<TextWeb>{localized('False')}</TextWeb>
				</ViewWeb>
			),
		};
	}

	private SetNegativeCycleDaysToFalse = () => {
		this.setState(prevState => ({
			moveMatingToMatingSetup: {
				...prevState.moveMatingToMatingSetup,
				negativeCycleDays: false,
			},
		}));
	};

	private SetNegativeCycleDaysToTrue = () => {
		this.setState(prevState => ({
			moveMatingToMatingSetup: {
				...prevState.moveMatingToMatingSetup,
				negativeCycleDays: true,
			},
		}));
	};

	private getWorkListSetting(type: WorkListType) {
		let workListSetting = this.props.workListSettings.find(
			setting => setting.type === type,
		) as MoveMatingToMatingSetting;
		if (!workListSetting) {
			workListSetting = MoveMatingToMatingSetting.fromJS({ type, showOnApp: true });
		}
		return workListSetting;
	}

	private renderButtons() {
		return (
			<ViewWeb className="buttons-container">
				<SkioldButton title={localized('Save')} onPress={() => this.save()} />
			</ViewWeb>
		);
	}

	private renderOption = (defaultCurve: DefaultFeedCurve | undefined) => {
		if (defaultCurve) {
			const curve = this.props.feedCurvesOptions.find(
				curve =>
					defaultCurve.feedCurveNumber !== undefined &&
					defaultCurve.feedCurveNumber !== null &&
					curve.value === defaultCurve.feedCurveNumber.toString(),
			);

			if (curve) {
				return curve;
			}
		}
		return { label: '', value: '' };
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(MoveMatingToMatingSetup);
